module.exports = __webpack_public_path__ + "img/BH.ca5755d8.png";